import { SearchViewWithConfirmation } from '@wrisk/ui-components'
import React, { FunctionComponent, HTMLInputTypeAttribute, useCallback } from 'react'

import { DataEntry } from '../../../../../../domain'
import { TKeyBuilder } from '../../../../../../infrastructure/internationalisation'
import { DataEntrySearchView } from './DataEntrySearchView'

interface DataEntryFinderProps {
  endpoint: string
  onSelect: (value: DataEntry | undefined) => void
  tKey: TKeyBuilder
  validate: (text: string) => boolean
  placeholder: string
  characterLimit?: number
  inputType?: HTMLInputTypeAttribute
}

export const DataEntryFinder: FunctionComponent<DataEntryFinderProps> = (props) => {
  const { endpoint, tKey, onSelect, validate, placeholder, characterLimit, inputType } =
    props

  const renderSearch = useCallback(
    (f: (r: DataEntry) => void) => (
      <DataEntrySearchView
        endpoint={endpoint}
        tKey={tKey}
        onSubmit={f}
        validate={validate}
        placeholder={placeholder}
        characterLimit={characterLimit}
        inputType={inputType}
      />
    ),
    [],
  )
  const renderConfirmationLabel = useCallback((t: DataEntry) => <>{t.name}</>, [])

  return (
    <SearchViewWithConfirmation
      onChange={onSelect}
      renderConfirmation={renderConfirmationLabel}
      renderSearch={renderSearch}
    />
  )
}
